module.exports = __webpack_public_path__ + "img/help-datahikitsugi.dbe5a4a8.png";